<template>
  <div>
    <page-header title="Shipment Timeline" breadcrumb="Dashboard > Bookings & Shipments  > Trackings" :back="back" />

    <div class="bg-white">
      <div class="time_info_container pad pt-3">
        <p class="time_comntain">
          <b class="shiipin_ref">Dispatch ID: #MX001234</b>
          <span class="shipping_time">Tusday August 3, 2022, 10:00AM</span>
        </p>
        <button class="update_status">Update Status</button>
      </div>

      <div class="ship_icon_container">
        <div class="ship_icon">
          <img src="../components/icons/ShipIcon.svg" />
        </div>
        <div>
          <p class="ship_icon_title">Standard Shipping</p>
          <p>This order has been shipped to the customer</p>
        </div>
      </div>

      <div>
        <TabIndicator :index="4" />
      </div>

      <div class="pad bg-primary-lightgrey py-3">
        <div class="dispatcher_header">
          <h6>Dispatch Information</h6>
          <span>Collapse</span>
        </div>

        <div class="flex flex-wrap w-full">
          <div class="lg:w-3/12 md:w-4/12 sm:w-6/12 w-full">
            <DetailItem img="" label="Regina Smith" title="SENDER INFORMATION">
              <abbr class=" text-red-500">(+234) 803 341 8901</abbr>
             </DetailItem>
             <DetailItem img="" label="" title="" noHeader="yes">
              <abbr class="">7b Montgomery Drive
                Friend’s Coloney Estate
                Lekki, Lagos State
                Nigeria</abbr>
             </DetailItem> 
          </div>
          <div class="lg:w-3/12 md:w-4/12 sm:w-6/12 w-full">
            <DetailItem img="" label="Regina Smith" title="SENDER INFORMATION">
              <abbr class=" text-red-500">(+234) 803 341 8901</abbr>
             </DetailItem>
             <DetailItem img="" label="" title="" noHeader="yes">
              <abbr class="">77 Nwodo Street
                GRA
                Enugu, Enugu State
                Nigeria</abbr>
             </DetailItem> 
          </div>

          <div class="lg:w-3/12 md:w-4/12 sm:w-6/12 w-full">
            <DetailItem img="" label="Cloudenly" title="ORDER CHANNEL">
              <abbr class=" text-red-500">(+234) 803 341 8901</abbr>
             </DetailItem>
             <DetailItem img="" label="MX001234" title="ORDER #"> </DetailItem>
             <DetailItem img="" label="N208,000" title="INSURED VALUE"> </DetailItem>
          </div>
          <div class="lg:w-3/12 md:w-4/12 sm:w-6/12 w-full ">
            <DetailItem img="" label="N12,500" title="SHIPPING COST"></DetailItem>
            <DetailItem img="" label="Paid" title="PAYMENT STATUS"></DetailItem>
            <DetailItem img="" label="**** **** **** 7865" title="CARD"></DetailItem>
          </div>
        </div>
      </div>

    
    <div class="text-left py-5 overflow-x-auto">
      <h5 class="mb-3 px-4">Order Items</h5>
      <table width="100%">
        <thead class="shadow-sm">
          <tr >
            <th class="pl-4 py-2">Item</th>
            <th>Quantity</th>
            <th>Dimension (Cm)</th>
            <th>Gross weight (Kg)</th>
            <th>Total Cost (N)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in [1,2,3]" :key="item" class="shadow-sm">
            <td>Bale of Clothes</td>
            <td>10</td>
            <td>60x20x30</td>
            <td>
              100
            </td>
            <td>
              200,000
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import DetailItem from "../components/DetailItem.vue"
import TabIndicator from "../components/TabIndicator.vue"

export default {
  components: {
    PageHeader,
    DetailItem,
    TabIndicator
  },
  props: ['back'],
  data() {
    return {

    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.dispatcher_info{
  width: 25%
}
.dispatcher_header{
  @apply mt-6 mb-3 flex items-center;
  h6{
    font-weight: 600;
    @apply w-full;
  }
}
.ship_icon_title {
  @apply text-xl font-normal
}

.ship_icon {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  @apply bg-white flex justify-center items-center mr-3;
}

.ship_icon_container {
  @apply flex items-center bg-primary-green px-4 py-3 text-white mt-4
}

.pad {
  @apply px-4
}

.update_status {
  @apply bg-secondary-yellow px-8 py-2 rounded
}

.time_comntain {
  @apply flex-1
}

.shiipin_ref {
  @apply text-xl mr-2;
  font-weight: 500;
}

.shipping_time {
  @apply opacity-50 text-sm
}

.time_info_container {
  @apply flex items-center flex-wrap
}
</style>